import { Box, ListItem, Text } from '@chakra-ui/core';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Notification } from '../../../firebase/firestore/documents/notification';
import { useStoreActions } from '../../../models/hooks';
import { useMessagingViewContext } from '../../../modules/messaging/MessagingViewContext';
import { SeekerContainerTabItems } from '../../../modules/messaging/seeker/SeekerContainerContext';
import { MESSAGING_CANDIDATE_TABS } from '../../../routes/constants';
import { NotificationStatusIcon } from './NotificationStatusIcon';
import { getConsistentDateFormat } from '../../../utils/dateUtils';

export type I9CheckViewProps = {
  notifications: Notification[];
};

export const I9CheckView = ({ notifications }: I9CheckViewProps): JSX.Element => {
  const history = useHistory();
  const { setSelectedEngagedCandidate, setSelectedEngagedSeeker, setSelectedCandidateId } = useMessagingViewContext();

  const { readNotification } = useStoreActions((actions) => actions.topBarNotification);

  const selectedCallback = useCallback(
    (candidateId?: Notification['candidate']) => {
      if (candidateId) {
        setSelectedCandidateId(candidateId);
        history.push(MESSAGING_CANDIDATE_TABS(candidateId, SeekerContainerTabItems.Messaging));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setSelectedEngagedCandidate, setSelectedEngagedSeeker],
  );

  const readNotificationInvitation = async (notification: Notification) => {
    selectedCallback(notification.candidate);
    await readNotification({ notificationId: notification.id });
  };

  return (
    <>
      {notifications.length > 0 &&
        notifications?.map((notificationData) => {
          return (
            <ListItem
              key={notificationData.id}
              d="flex"
              alignItems="start"
              px={5}
              py={4}
              borderBottom="1px solid #EBEBEB"
              style={{ cursor: 'pointer' }}
              data-testid="NotificationBlock"
              onClick={() => readNotificationInvitation(notificationData)}
              className={notificationData.new ? '' : 'read-notification'}
            >
              <Box w="100%">
                <Box display="flex" flexDirection="row" justifyContent="space-between">
                  <Box w="70%">
                    <Text
                      fontSize="sm"
                      fontWeight="700"
                      dangerouslySetInnerHTML={{
                        __html: notificationData.title,
                      }}
                    />

                    <Text
                      fontSize="sm"
                      dangerouslySetInnerHTML={{
                        __html: notificationData.message,
                      }}
                    />
                    <Text fontSize="xs" color="#A0AEC0">
                      {getConsistentDateFormat(notificationData.sentAt, 'full', 'atTime')}
                    </Text>
                  </Box>
                  <Box>
                    <NotificationStatusIcon notificationType={notificationData.notificationType} />
                  </Box>
                </Box>
              </Box>
            </ListItem>
          );
        })}
    </>
  );
};
